import { Component, OnInit } from '@angular/core';
import { GetDataService } from '../../services/userService/get-data.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-home-page',
  imports: [CommonModule,FormsModule],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent implements OnInit{
  versionWithCount:any[] = [];
  constructor(private _dataService : GetDataService){

  }
  ngOnInit(): void {
    this._dataService.getVersions().subscribe((res:any)=>{
      this.versionWithCount = res.versionWithCount;
    })
  }
}
